// Import the shared styles
import '~/assets/styles/shared.css';

import * as Sentry from '@sentry/browser';

if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.APP_ENV,
    release: process.env.BUILD_VERSION,
  });
}
